import { PulseBaseProvider } from '../../base-classes';

const _getWeatherCamsCacheKey = 'getWeatherCams';
const _getWeatherCamsUri='/data/cameras/v2/CameraList';

const _getWeatherCamDetailCacheKey = 'getWeatherCamDetail';
const _getWeatherCamDetailUri='/data/cameras/v2/CameraAnimations';

export class WeatherCamProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_getWeatherCamsCacheKey] = this.getWeatherCamsSyncer.bind(this);
        this.storage.sync[_getWeatherCamDetailCacheKey] = this.getWeatherCamDetailSyncer.bind(this);
    }

    async getWeatherCamsSyncer(params) {
        const {
            id
            , syncParams
            , resolve
            , reject
        } = params;

        const queryParams = {
            ...syncParams.stdParameters
            , la: syncParams.latitude
            , lo: syncParams.longitude
            , r: syncParams.radius
            , ns: syncParams.noOfStations
            , ii: syncParams.includeImages
            , verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getWeatherCamsUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , null
        );
    }

    async getWeatherCams(latitude, longitude, radius = 500, noOfStations = 20, includeImages = 1, stdParameters, verbose, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            latitude,
            longitude,
            radius,
            noOfStations,
            includeImages,
            refresh,
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh)
        {
            super.removeFromStorage(_getWeatherCamsCacheKey, id);
        }
        return await super.loadFromStorage(_getWeatherCamsCacheKey, id, syncParams);
    }

    async getWeatherCamDetailSyncer(params) {
        const {
            id
            , syncParams
            , resolve
            , reject
        } = params;

        const queryParams = {
            ...syncParams.stdParameters
            , ci: syncParams.cameraId
            , itl: syncParams.includeTimelapse
            , verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getWeatherCamDetailUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , null
        );
    }

    async getWeatherCamDetail(cameraId, includeTimelapse = 1, stdParameters, verbose, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            cameraId,
            includeTimelapse,
            refresh,
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh)
        {
            super.removeFromStorage(_getWeatherCamDetailCacheKey, id);
        }
        return await super.loadFromStorage(_getWeatherCamDetailCacheKey, id, syncParams);
    }
}
